'use client';

import PaginatedGrid, { GridType } from '@components/PaginatedGrid';
import searchLearnByCategory from '@api/learn/getLearnByCategory';
import GridItem from './_GridItem';

import type { Data } from '@typings/productGrid';

interface LearnCategoryGridProps {
  category: Array<string>;
  tags?: Array<string>;
  locale: string;
  _data?: Data;
}

const LearnCategoryGrid = ({ category, tags, locale, _data }: LearnCategoryGridProps) => {
  const loadData = async ({ page }: { page: number }) => {
    return searchLearnByCategory({ category, tags, lang: locale, page });
  };

  return (
    <PaginatedGrid
      _data={_data}
      loadData={loadData}
      GridItemComponent={GridItem}
      type={GridType.Learn}
    />
  );
};

export default LearnCategoryGrid;
